// Page title and meta data configuration
export const pageConfig = {
  home: {
    title: 'Lifelike AI avatars to replace real-world models.',
    description: 'Create stunning AI-generated avatars with our advanced technology. Professional, customizable, and ready for any platform.',
    image: '/img/hero-avatar.jpg', // You'll need to add this image
    url: '/'
  },
  avatars: {
    title: 'Avatar Gallery',
    description: 'Explore our collection of AI-generated avatars. Professional headshots, creative portraits, and customizable styles.',
    image: '/img/avatar-gallery.jpg', // You'll need to add this image
    url: '/avatars'
  },
  pricing: {
    title: 'Pricing & Plans',
    description: 'Choose the perfect plan for your avatar generation needs. Affordable pricing with professional results.',
    image: '/img/pricing-hero.jpg', // You'll need to add this image
    url: '/pricing'
  },
  howItWorks: {
    title: 'How It Works',
    description: 'Learn how our AI avatar generation technology works. Simple process, professional results in minutes.',
    image: '/img/how-it-works.jpg', // You'll need to add this image
    url: '/how-it-works'
  },
  examples: {
    title: 'Examples',
    description: 'See real transformations from brands using ITORA. Before and after comparisons showcase the power of AI-generated avatars.',
    image: '/img/examples-hero.jpg', // You'll need to add this image
    url: '/examples'
  },
  demo: {
    title: 'Demo - Mary Young Case Study',
    description: 'See how Mary Young used ITORA to reduce intimates add-on costs with AI-generated avatar replacements.',
    image: '/img/examples/my/my_a.png',
    url: '/demo'
  },
  contact: {
    title: 'Contact Us',
    description: 'Get in touch with our team. We\'re here to help with your avatar generation needs.',
    image: '/img/contact-hero.jpg', // You'll need to add this image
    url: '/contact'
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    description: 'Learn how we protect your privacy and handle your data when using our AI avatar generation service.',
    url: '/privacy-policy'
  },
  termsOfService: {
    title: 'Terms of Service',
    description: 'Read our terms of service for using the AI avatar generation platform.',
    url: '/terms-of-service'
  }
};

// Avatar-specific titles (for individual avatar pages)
export const getAvatarTitle = (avatarName, filter = 'all') => {
  const filterLabels = {
    all: 'All',
    men: 'Men',
    women: 'Women'
  };
  
  if (avatarName) {
    // Convert avatar name to title case
    const titleCaseName = avatarName
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return `Avatars | ${titleCaseName}`;
  }
  
  return `Avatars | ${filterLabels[filter] || 'All'}`;
};

// Helper function to get page config by path
export const getPageConfig = (path) => {
  const pathMap = {
    '/': 'home',
    '/avatars': 'avatars',
    '/pricing': 'pricing',
    '/how-it-works': 'howItWorks',
    '/examples': 'examples',
    '/demo': 'demo',
    '/contact': 'contact',
    '/privacy-policy': 'privacyPolicy',
    '/terms-of-service': 'termsOfService'
  };
  
  return pageConfig[pathMap[path]] || pageConfig.home;
}; 